import React from "react";
import styled from "styled-components";
import DomeHeader from "../components/DomeHeader";
import Breakpoints from "../components/styles/Breakpoints";
import { Colors } from "../components/styles/Colors";
import { DomeText, Header2, AcmeWide, ProximaNova, Header6 } from "../components/typography";
import richText from "../utils/richText";
import Image from "gatsby-image";
import Signatures from './../assets/images/signatures.png'

const Wrapper = styled.div`
  padding: 64px 0px 20px 0px;
  background: ${Colors.cream1};

  @media ${Breakpoints.desktop} {
    padding: 64px 0px 150px 0px;
  }

  ${Header2} {
    margin: 24px auto 50px;
    max-width: 800px;

    color: ${Colors.grey};
    text-align: center;

    @media ${Breakpoints.desktop} {
      margin: 24px auto 120px;
    }
  }
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 0px 25px;

  @media ${Breakpoints.desktop} {
    padding: 0px;
  }

  .image {
    width: 100%;
    height: 40vh;
    position: relative;

    @media ${Breakpoints.desktop} {
      width: 50%;
      height: auto;
      padding: 0px 30px 0px 0px;
    }

    .gatsby-image-wrapper {
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
    }
  }

  .text-section {
    width: 100%;
    padding: 40px 0px 90px 0px;

    @media ${Breakpoints.desktop} {
      width: 50%;
      padding: 90px 60px 90px 30px;
    }

    .title p {
      font-family: ${AcmeWide};
      font-weight: 300;

      margin-bottom: 50px;

      font-size: 32px;
      line-height: 45px;

      color: ${Colors.darkGrey};
    }

    .text {
      margin-bottom: 50px;

      p {
        font-family: ${ProximaNova};
        font-weight: 300;

        font-size: 22px;
        line-height: 1.4;

        margin-bottom: 22px;
      }
    }

    img {
      width: 270px;
    }
  }
`;

export default function FoundersNote({ intro, text, image }) {
  return (
    <Wrapper>
      <DomeHeader text="What we're about" centered />
      <Header2>Founders' Note</Header2>
      <Row>
        <div className="image">
          <Image style={{ position: 'absolute' }} fluid={image.fluid} />
        </div>
        <div className="text-section">
          <div className="title">{ richText(intro.raw) }</div>
          <div className="text">{ richText(text.raw) }</div>
          <img src={Signatures}/>
        </div>
      </Row>
    </Wrapper>
  );
}
